import { DownloadRecordType } from '@drift/common';
import { SelectOption } from 'src/components/primitives/Select/hooks/types';

export const EXPORT_HISTORY_TYPES: SelectOption<DownloadRecordType>[] = [
	{
		label: 'Trades',
		value: 'trades',
	},
	{
		label: 'Market Trades',
		value: 'market-trades',
	},
	{
		label: 'Settle P&L Records',
		value: 'settle-pnl-records',
	},
	{
		label: 'Funding Rates',
		value: 'funding-rates',
	},
	{
		label: 'Funding Payments',
		value: 'funding-payments',
	},
	{
		label: 'Deposits/Withdrawals',
		value: 'deposits',
	},
	{
		label: 'Liquidations',
		value: 'liquidations',
	},
	{
		label: 'BAL Records',
		value: 'lp-records',
	},
	{
		label: 'IF Stake Records',
		value: 'if-stake-records',
	},
	{
		label: 'Swap Records',
		value: 'swap-records',
	},
];

export const EXPORT_HISTORY_MONTHS: SelectOption<number>[] = [
	{
		label: 'All',
		value: 0,
	},
	{
		label: 'January',
		value: 1,
	},
	{
		label: 'February',
		value: 2,
	},
	{
		label: 'March',
		value: 3,
	},
	{
		label: 'April',
		value: 4,
	},
	{
		label: 'May',
		value: 5,
	},
	{
		label: 'June',
		value: 6,
	},
	{
		label: 'July',
		value: 7,
	},
	{
		label: 'August',
		value: 8,
	},
	{
		label: 'September',
		value: 9,
	},
	{
		label: 'October',
		value: 10,
	},
	{
		label: 'November',
		value: 11,
	},
	{
		label: 'December',
		value: 12,
	},
];

export const EXPORT_HISTORY_DAYS: SelectOption<number>[] = [
	{ label: 'All', value: 0 },
	...Array.from({ length: 31 }, (_, i) => ({
		label: String(i + 1),
		value: i + 1,
	})),
];
